import { createApp } from 'vue';
import Mp3ToM4aConverter from '@/Components/Mp3ToM4aConverter.vue';
import '@styles/app.css';

createApp(Mp3ToM4aConverter).mount('#mp3-to-m4a-converter');
